import {useContext, useMemo} from 'react';
import DataClientContext from 'src/internal/revamp/config/DataClientContext';

import type InteroperabilityLayer from 'src/internal/revamp/interoperability/InteroperabilityLayer';

export default function useInteroperabilityLayer(): InteroperabilityLayer | null {
  const dataClient = useContext(DataClientContext);

  const interoperabilityLayer = useMemo(() => {
    if (!('graphQlDataClient' in dataClient) || !dataClient.graphQlDataClient) {
      return null;
    }

    return dataClient.graphQlDataClient.interoperabilityLayer;
  }, [dataClient]);

  return interoperabilityLayer;
}
